import { ReactElement, ReactNode, useRef, useState } from "react";

export default function ImageWithFallback({
  image,
  fallback,
}: {
  image: ReactElement<HTMLImageElement>;
  fallback?: ReactElement<ReactNode> | null;
}) {
  const [isLoading, setLoading] = useState(!!image.props.src);
  const [isError, setError] = useState(false);
  const dummyRef = useRef<HTMLImageElement | null>(null);
  const shouldShowFallback = !image.props.src || isLoading || isError;

  return (
    <>
      {isLoading && !isError && image.props.src && (
        <img
          ref={dummyRef}
          style={{ display: "none" }}
          src={image.props.src}
          alt="test"
          onLoad={() => {
            setLoading(false);
          }}
          onError={() => {
            setError(true);
          }}
        />
      )}
      {shouldShowFallback ? fallback : image}
    </>
  );
}
